import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, catchError } from 'rxjs';
import { PensionContributionEmployee, PensionSubmissionError } from './pension-contribution-employee.model';
import { environment } from '@env/environment';
import { LoggingService } from '@logging/logging.service';

@Injectable()
export class PensionContributionsDataProvider {
  private readonly apiRoot = `${environment.apiPaths.pensions}`;

  constructor(
    private readonly http: HttpClient,
    private readonly logger: LoggingService
  ) {}

  getSubmissionContributions$(closedPeriodId: number): Observable<PensionContributionEmployee[]> {
    return this.http.get<PensionContributionEmployee[]>(`${this.apiRoot}/submission/${closedPeriodId}/contributions`).pipe(
      catchError((error) => {
        this.logger.error('Failed to fetch pension contributions', error);
        return of([]);
      })
    );
  }

  getSubmissionSubmisssionsErrors$(closedPeriodId: number): Observable<PensionSubmissionError[]> {
    return this.http.get<PensionSubmissionError[]>(`${this.apiRoot}/submission/${closedPeriodId}/closed-period-errors`).pipe(
      catchError((error) => {
        this.logger.error('Failed to fetch submission errors', error);
        return of([]);
      })
    );
  }

  getSubmissionPaymentErrors$(closedPeriodId: number): Observable<any[]> {
    // TODO: Define proper type once API is implemented
    return this.http.get<any[]>(`${this.apiRoot}/submission/${closedPeriodId}/payment-errors`).pipe(
      catchError((error) => {
        this.logger.error('Failed to fetch submission errors', error);
        return of([]);
      })
    );
  }
}
